import {createSlice} from '@reduxjs/toolkit';
import {InvitedUserFields} from 'hubbl-shared';
import {
  setInvitedEmployees,
  setUserFullName,
  setWrittenCompanyName,
  setRestrictedMailDomains,
} from './GetStartedThunks';

interface GetStartedState {
  writtenCompanyName: string;
  userFullName: string;
  invitedEmployees: InvitedUserFields[];
  restrictedMailDomains: string[];
}

const initialState: GetStartedState = {
  writtenCompanyName: '',
  userFullName: '',
  invitedEmployees: [],
  restrictedMailDomains: [],
};

export const getStartedSlice = createSlice({
  name: 'get-started',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(setWrittenCompanyName.fulfilled, (state, action) => {
      state.writtenCompanyName = action.payload;
    });
    builder.addCase(setUserFullName.fulfilled, (state, action) => {
      state.userFullName = action.payload;
    });
    builder.addCase(setInvitedEmployees.fulfilled, (state, action) => {
      state.invitedEmployees = action.payload;
    });
    builder.addCase(setRestrictedMailDomains.fulfilled, (state, action) => {
      state.restrictedMailDomains = action.payload;
    });
  },
});

export const {} = getStartedSlice.actions;

export const GetStartedReducer = getStartedSlice.reducer;
